module.exports = __webpack_public_path__ + "img/icon-dropdown.587228ad.svg";